'use strict';

import angular from 'angular';

function GrpRoleTypeResource($resource) {
  return $resource('/api/groups/:groupId/roletypes/:id/:controller', {
    id: '@id'
  }, {
    getPermissions: { // query params used for instead of url :id
      method: 'GET',
      params: {
        controller: 'permissions'
      }
    }
  });
}

GrpRoleTypeResource.$inject = ['$resource'];

export default angular.module('georgeApp.grpRoleTypeSvc', [])
  .factory('GrpRoleTypeSvc', GrpRoleTypeResource)
  .name;
